import { put, takeEvery } from "redux-saga/effects";

//Actions
import * as ACTIONS from "./../../actions/actionConstants";
import { actions } from "react-redux-form";

//Auth
import { auth, db } from "./../../firebase";

function* handleLogin(action) {
  //Unpack
  const { model } = action.meta;

  /*

    LOGIN

  */
  if (model === "forms.login") {
    const { email, password } = action.meta.payload;
    let errors = "";

    //Authenticate user first to access db.
    const authUser = yield auth
      .doSignInWithEmailAndPassword(email, password)
      .catch(err => {
        //If email error
        if (err.code === "auth/user-not-found") {
          errors = "userNotFound";
        }

        //If password error
        else if (err.code === "auth/wrong-password") {
          errors = "incorrectPassword";
        }
      });

    //If authenticated, check user status to determine if it's active.
    let hasActiveStatus;
    if (authUser) {
      //Get list of users.
      const usersSnapshot = yield db
        .onceGetUsers()
        .catch(err => console.log(err));

      //Check status and return true if active, defaults to false.
      hasActiveStatus = Object.keys(usersSnapshot.val()).reduce((a, i) => {
        let user = usersSnapshot.val()[`${i}`];
        if (user.profile.email.toLowerCase() === email.toLowerCase()) {
          if (user.status === "active") {
            a = true;
            return a;
          }
        }
        return a;
      }, false);
    }

    //If user isn't active, logout, reset, and reroute.
    if (!hasActiveStatus) {
      auth.doLogout();
      yield put({ type: ACTIONS.IS_AUTHENTICATED, payload: false });
      yield put({ type: ACTIONS.RESET_USER });

      //Add to errors form
      yield put(actions.change("forms.errors.hasErrors", errors));

      //Snackbars
      if (errors === "userNotFound") {
        yield put({
          type: ACTIONS.OPEN_SNACKBAR,
          payload: {
            variant: "error",
            message: `user not found`
          }
        });
      } else if (errors === "incorrectPassword") {
        yield put({
          type: ACTIONS.OPEN_SNACKBAR,
          payload: {
            variant: "error",
            message: `incorrect password`
          }
        });
      } else if (!hasActiveStatus) {
        yield put({
          type: ACTIONS.OPEN_SNACKBAR,
          payload: {
            variant: "error",
            message: `user login privilages revoked`
          }
        });
      }

      //Reroute
      yield put({
        type: ACTIONS.RE_ROUTE,
        path: "login"
      });
    }

    //Get UID
    let uid = authUser ? authUser.user.uid : null;

    //Load User from DB if UID
    const userSnapshot = uid
      ? yield db.onceGetUser(uid).catch(err => console.log(err))
      : null;

    if (userSnapshot && hasActiveStatus && !errors) {
      //Check to see if client
      const isUser = userSnapshot.val().role === "user";

      //If isUser, log the login
      if (isUser) {
        /*

        Changed to init (onStateChange)

        */
        yield put({ type: ACTIONS.HIT_LOGS, filter: "login" });
      }

      //Reset
      yield put(actions.reset("forms.login"));

      //Set Auth
      yield put({ type: ACTIONS.IS_AUTHENTICATED, payload: true });

      //Init watchers
      yield put({
        type: ACTIONS.DB_SYNC,
        uid: uid,
        role: userSnapshot.val().role
      });

      //Dispatch to User
      yield put({
        type: ACTIONS.UPDATE_USER,
        payload: { ...userSnapshot.val(), userDataFetched: true }
      });

      //Route to dashboard
      yield put({
        type: ACTIONS.RE_ROUTE,
        path: "dashboard"
      });

      //Display snackbar
      const name = userSnapshot.val().profile.name;
      yield put({
        type: ACTIONS.OPEN_SNACKBAR,
        payload: {
          variant: "success",
          message: `${name.toLowerCase()} is logged in`
        }
      });
    }

    //Set pending to false when finished
    yield put(actions.setPending("forms.login", false));
  }
}

export function* loginSaga() {
  yield takeEvery(ACTIONS.SUBMIT_LOGIN, handleLogin);
}



// WEBPACK FOOTER //
// ./src/sagas/auth/login.js